<template>
  <div class="p-2">
    <b-card header="Default">
      <div slot="header">{{ $lang.editResearchPlan }}</div>
      <div class="text-center" v-if="isLoading">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <registerPlanFrom
        v-if="!isLoading"
        :item="item"
        :parentPermissions="parentPermissions"
        @modal-end-up="afterSave"
        @submit="save"
        @closeModal="closeModal"
      />
    </b-card>
  </div>
</template>

<script>
import registerPlanFrom from "./../forms/registerPlanFrom";
import { pathOr } from "ramda";

export default {
  components: {
    registerPlanFrom,
  },
  name: "edit-task",
  inject: ["researchPlanRepository"],
  props: {
    query: {
      type: Object,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => {},
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      isLoading: false,
    };
  },
  methods: {
    pathOr,
    closeModal() {
      this.$emit("closeModal");
    },
    afterSave() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
        // this.handleBack();
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    async save(payload) {
      try {
        this.isLoading = true;
        const researchId = pathOr(null, ["id"], this.item);
        const url =
          this.$config.api_url +
          this.$config.research.research_queue_plan_detail
            .replace("{0}", this.id)
            .replace("{1}", researchId);
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.$emit("getData");
        this.closeModal();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

